
import React, { useState, useRef, useEffect } from 'react';

export const SignatureGenerator: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  // Form fields
  const [name, setName] = useState('NAME');
  const [role, setRole] = useState('ROLE');
  const [email, setEmail] = useState('email@irreverentia.eu');
  const [phone, setPhone] = useState('+34 000 000 000');
  const [copied, setCopied] = useState(false);

  // Password: IRR3V_2025 (puedes cambiarla aquí)
  const MASTER_KEY = 'IRR3V_2025';

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === MASTER_KEY) {
      setIsAuthenticated(true);
      setError(false);
    } else {
      setError(true);
      setPassword('');
      // Shake effect or feedback
    }
  };

  // Logo GIF URL (Referencia solicitada: ISO -> LOGO)
  const logoGifUrl = "http://irreverentia.eu/images/logo-animated-sig.gif";

  const signatureHtml = `
<table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; color: #ffffff; background-color: #000000; width: 450px; border-collapse: collapse;">
  <tr>
    <td style="padding: 20px; width: 120px; vertical-align: middle; border-right: 2px solid #ccff00;">
      <a href="http://irreverentia.eu" target="_blank" style="text-decoration: none;">
        <img src="${logoGifUrl}" alt="IRREVERENTIA" width="100" style="display: block; border: 0;" />
      </a>
    </td>
    <td style="padding: 20px; vertical-align: middle;">
      <div style="font-size: 18px; font-weight: bold; color: #ccff00; text-transform: uppercase; margin-bottom: 4px; letter-spacing: 1px;">
        ${name}
      </div>
      <div style="font-size: 11px; font-weight: bold; color: #ffffff; text-transform: uppercase; margin-bottom: 15px; letter-spacing: 2px; background-color: #27272a; display: inline-block; padding: 2px 6px;">
        ${role}
      </div>
      <div style="font-size: 12px; color: #a1a1aa; line-height: 1.6;">
        <span style="color: #ccff00; font-weight: bold;">M:</span> ${phone}<br />
        <span style="color: #ccff00; font-weight: bold;">E:</span> <a href="mailto:${email}" style="color: #a1a1aa; text-decoration: none;">${email}</a><br />
        <span style="color: #ccff00; font-weight: bold;">W:</span> <a href="http://irreverentia.eu" style="color: #a1a1aa; text-decoration: none;">irreverentia.eu</a>
      </div>
    </td>
  </tr>
  <tr>
    <td colspan="2" style="background-color: #b026ff; padding: 4px 20px; font-size: 9px; font-weight: bold; color: #000000; text-transform: uppercase; letter-spacing: 3px; text-align: center;">
      /// STORYTELLING POWERED BY AI ///
    </td>
  </tr>
</table>
  `;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(signatureHtml).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  if (!isAuthenticated) {
    return (
      <div className="pt-24 pb-20 px-6 min-h-screen bg-black flex flex-col items-center justify-center scanlines">
        <div className="max-w-md w-full p-8 border-4 border-zinc-800 bg-zinc-950 shadow-[10px_10px_0px_0px_#ccff00]">
          <div className="mb-8 text-center">
            <h1 className="font-display font-black text-4xl text-white uppercase tracking-tighter mb-2">SECURED_ACCESS</h1>
            <p className="font-mono text-zinc-500 text-[10px] uppercase tracking-widest">Protocol: IDENTITY_LAB_v1.0</p>
          </div>
          
          <form onSubmit={handleLogin} className="space-y-6">
            <div className="relative">
              <label className="block font-mono text-[9px] text-acid uppercase mb-2">Enter Master Key</label>
              <input 
                type="password" 
                autoFocus
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="********"
                className={`w-full bg-black border-2 ${error ? 'border-red-600' : 'border-zinc-800'} p-4 text-white font-mono text-center focus:outline-none focus:border-acid transition-colors`}
              />
              {error && (
                <p className="absolute -bottom-5 left-0 w-full text-center font-mono text-[9px] text-red-600 uppercase">Invalid key // Access Denied</p>
              )}
            </div>
            
            <button 
              type="submit"
              className="btn-8bit w-full py-4 text-xl"
            >
              INITIALIZE_LAB
            </button>
          </form>
          
          <div className="mt-8 pt-6 border-t border-zinc-900 flex justify-center">
             <span className="font-mono text-[8px] text-zinc-800 uppercase tracking-widest">¡RR3VERENT!A_SECURITY_NODE</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-24 pb-20 px-6 min-h-screen bg-black flex flex-col items-center scanlines">
      <div className="max-w-4xl w-full">
        
        <div className="mb-12 border-l-8 border-acid pl-8">
          <h1 className="font-display font-black text-6xl text-white uppercase tracking-tighter">SIG_LAB.EXE</h1>
          <p className="font-mono text-acid text-xs uppercase tracking-[0.3em] mt-2">Neural Identity Protocol v1.0</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          
          {/* Controls */}
          <div className="bg-zinc-900 p-8 border-2 border-zinc-800 shadow-[10px_10px_0px_0px_#ccff00]">
            <h3 className="font-display font-bold text-2xl text-white mb-8 uppercase">IDENTITY_INPUT</h3>
            <div className="space-y-6">
              <div>
                <label className="block font-mono text-[10px] text-zinc-500 uppercase mb-2">Full Name</label>
                <input 
                  type="text" 
                  value={name} 
                  onChange={(e) => setName(e.target.value)}
                  className="w-full bg-black border border-zinc-800 p-3 text-white font-mono text-sm focus:border-acid focus:outline-none"
                />
              </div>
              <div>
                <label className="block font-mono text-[10px] text-zinc-500 uppercase mb-2">Neural Role</label>
                <input 
                  type="text" 
                  value={role} 
                  onChange={(e) => setRole(e.target.value)}
                  className="w-full bg-black border border-zinc-800 p-3 text-white font-mono text-sm focus:border-acid focus:outline-none"
                />
              </div>
              <div>
                <label className="block font-mono text-[10px] text-zinc-500 uppercase mb-2">Comms Channel (Email)</label>
                <input 
                  type="email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-black border border-zinc-800 p-3 text-white font-mono text-sm focus:border-acid focus:outline-none"
                />
              </div>
              <div>
                <label className="block font-mono text-[10px] text-zinc-500 uppercase mb-2">Direct Link (Phone)</label>
                <input 
                  type="text" 
                  value={phone} 
                  onChange={(e) => setPhone(e.target.value)}
                  className="w-full bg-black border border-zinc-800 p-3 text-white font-mono text-sm focus:border-acid focus:outline-none"
                />
              </div>
            </div>

            <button 
              onClick={copyToClipboard}
              className="btn-8bit w-full mt-10 py-4 text-xl"
            >
              {copied ? 'COPIED_TO_BUFFER' : 'GENERATE_CODE'}
            </button>
          </div>

          {/* Preview */}
          <div className="flex flex-col gap-6">
            <h3 className="font-display font-bold text-2xl text-white uppercase border-b-2 border-zinc-900 pb-2">PREVIEW_RENDER</h3>
            
            <div className="p-10 bg-[#0a0a0a] border-2 border-dashed border-zinc-800 flex items-center justify-center">
              <div 
                dangerouslySetInnerHTML={{ __html: signatureHtml }} 
                className="shadow-[0_0_30px_rgba(204,255,0,0.05)]"
              />
            </div>

            <div className="bg-zinc-950 p-6 border border-zinc-900 font-mono text-[10px] text-zinc-500 leading-relaxed overflow-x-auto">
              <p className="mb-4 text-acid">// RAW_HTML_STREAM</p>
              <code className="whitespace-pre">{signatureHtml}</code>
            </div>
          </div>

        </div>

        {/* Footer info */}
        <div className="mt-20 pt-8 border-t border-zinc-900 flex justify-between items-center text-zinc-700 font-mono text-[9px] uppercase tracking-widest">
           <span>Instruction: Copy code and paste into signature settings of your mail client.</span>
           <span>¡RR3VERENT!A_IDENTITY_STATION</span>
        </div>
      </div>
    </div>
  );
};
